import React, { useState } from "react";
import DOMPurify from "dompurify";

export default function DomPurifyTest() {
  const [input, setInput] = useState("");
  const [sanitized, setSanitized] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    setInput(raw);
    const clean = DOMPurify.sanitize(raw);
    setSanitized(clean);
  };

  return (
    <div style={{ padding: 24 }}>
      <h2>DOMPurify Test</h2>
      <input
        type="text"
        value={input}
        onChange={handleChange}
        placeholder="Type HTML or JS here"
        style={{ width: 400, padding: 8 }}
      />
      <div style={{ marginTop: 16 }}>
        <strong>Sanitized Output:</strong>
        <div
          style={{ padding: 12, background: "#eee", marginTop: 8 }}
          dangerouslySetInnerHTML={{ __html: sanitized }}
        />
      </div>
    </div>
  );
}
